<template>
	<a href="https://opensaludes.sharepoint.com/:b:/s/General2/EewHuG8R5t1BnvqeB1acUVUBNx-umeNWcdrRgYyuwB2dug?e=tfdM2E" target="_blank">
    <img class="vertical middle-icon" alt="ISO 27001 OCA logo" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/27001.png"/>
	</a>
</template>

<script>
export default {
	name: 'ISO27001Logo'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/utils/ISO27001Logo.vue